import dynamic from "next/dynamic";

export const Video = ({ value }) => {
  // If there's no Window object, this throws a hydration error
  const ReactPlayer = dynamic(() => import("react-player"), { ssr: false });

  const { url, fallback } = value;
  return (
    <div
      style={{
        maxWidth: "640px",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "4rem",
        marginBottom: "1rem",
      }}
    >
      <ReactPlayer
        playing
        url={url}
        poster={fallback}
        width="100%"
        controls
        muted
        loop
      />
    </div>
  );
};
